<template>
  <div class="logo">
    <div class="show-logo" v-if="getImageData.FileSource">
      <fileDisplay
        :fileSource="getImageData.FileSource"
        :fileHeader="getImageData.header"
      />
      <p class="body-1 filename">
        {{ getImageData.FileName }}.{{ getImageData.FileType }}
      </p>
      <qvoButton v-if="!readOnly" outlined warning @click="showConfirmation"
        >Remove</qvoButton
      >
    </div>
    <div class="set-logo" v-else>
      <template v-if="readOnly"><p class="subtitle-2">No image</p></template>
      <template v-else>
        <v-icon size="128">mdi-upload-outline</v-icon>
        <logoUploadModal @setConfigValue="setConfigValue" />
      </template>
    </div>
    <confirmationModal
      :value="isConfirmationDisplayed"
      title="Remove Logo?"
      @closeModal="cancelConfirmation"
    >
      <p>Are you sure you want to remove this logo?</p>
      <template #buttons>
        <qvoButton text @click="cancelConfirmation">Cancel</qvoButton>
        <qvoButton warning @click="removeLogo">Remove Logo</qvoButton>
      </template>
    </confirmationModal>
  </div>
</template>
  
<script>
/**
 * @fileoverview Config input for logos
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import { mapGetters } from "vuex";

import qvoButton from "@/qux-common/qux22/components/molecules/button";

import confirmationModal from "@/components/confirmation-modal";

import fileDisplay from "./file-display";
import logoUploadModal from "./logo-upload-modal";

export default {
  name: "LogoField",
  components: { qvoButton, confirmationModal, fileDisplay, logoUploadModal },
  data() {
    return {
      isConfirmationDisplayed: false,
    };
  },
  props: {
    category: {
      type: String,
    },
    id: {
      type: String,
    },
    parentField: {
      type: String,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    showConfirmation() {
      this.isConfirmationDisplayed = true;
    },
    cancelConfirmation() {
      this.isConfirmationDisplayed = false;
    },
    removeLogo() {
      this.setConfigValue({
        fieldId: "FileName",
        value: "",
      });
      this.setConfigValue({
        fieldId: "FileSource",
        value: "",
      });
      this.setConfigValue({
        fieldId: "FileType",
        value: "",
      });
      this.isConfirmationDisplayed = false;
    },
    setConfigValue(args) {
      this.$store.dispatch("setConfigValue", {
        ClientInfoRuleId: this.id,
        category: this.category,
        ...args,
      });
    },
    getConfigValue({ id, category = this.category }) {
      let configValue =
        this.mergedConfig[this.id] && this.mergedConfig[this.id][category];
      if (this.parentField !== undefined) {
        configValue =
          configValue &&
          this.mergedConfig[this.id][category][this.parentField] &&
          this.mergedConfig[this.id][category][this.parentField][id];
      } else {
        configValue = configValue && this.mergedConfig[this.id][category][id];
      }
      return configValue;
    },
  },
  computed: {
    getImageData() {
      const FileName = this.getConfigValue({ id: "FileName" });
      const FileSource = this.getConfigValue({ id: "FileSource" });
      const FileType = this.getConfigValue({ id: "FileType" });
      let header, data;
      if (FileSource) {
        [header, data] = FileSource.split(",");
      }
      return { FileName, FileSource, FileType, header, data };
    },
    ...mapGetters({
      mergedConfig: "getMergedConfig",
    }),
  },
};
</script>
  
<style lang="scss" scoped>
.logo {
  margin-bottom: $qvo-spacing-16;
  .show-logo {
    .filename {
      margin-top: $qvo-spacing-8;
      margin-bottom: $qvo-spacing-24;
      color: $qvo-color-grey-700;
    }
  }
  .set-logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 2px dashed $qvo-color-grey-400;
    border-radius: 8px;
    padding: $qvo-spacing-24;
    .v-icon {
      color: $qvo-color-blue-400;
    }
  }
}
</style>